export default "/images/hbm-logo.jpg?c5db1bb9f53e10a81782ec26e9e50431";